CheckoutV2.PaymentV2.ModalAddCard = function(checkout) {
    var addNewCardModal = this;

    this._onCardAdded = function() {};
    this._onModalHidden = function() {};
    this.isValid = true;
    this.newCard = null;

    this.$modal = $('#addCreditCardModal');
    this.$inputCardNumber = this.$modal.find('input[name="cardnumber"]');
    this.$inputExpirationMonth = this.$modal.find('input[name="expireMonth"]');
    this.$inputExpirationYear = this.$modal.find('input[name="expireYear"]');
    this.$inputCardCVV = this.$modal.find('input[name="cvv"]');

    this._init = function() {
        addNewCardModal._listen();
    };

    this._listen = function() {
        addNewCardModal.$modal.find('.js-add-credit-card-btn').on('click', function(e) {
            e.preventDefault();

            checkout.payment.loading( "Verifying Payment Data" );
            addNewCardModal.newCard.clearFieldErrors();

            addNewCardModal._getCardData( function( cardData ) {
                checkout.payment.loading( false );
                if( cardData.nonce ) {
                    if ( cardData.hostedFieldsInterface ) {
                        cardData.hostedFieldsInterface.teardown();
                        cardData.hostedFieldsInterface = null;
                    }
                    addNewCardModal._onCardAdded( cardData );
                    addNewCardModal.hide();
                }
                else {
                    addNewCardModal.newCard.showFieldErrors( cardData );
                }
            } );

            if(addNewCardModal.isValid){
            }
        });

        addNewCardModal.$modal.on('hidden.bs.modal', function(e){
            addNewCardModal._onModalHidden();
        });
        
        addNewCardModal.$modal.find('.js-what-is-this').popover({
            content: $('.js-popover-wrapper').html(),
            html: true,
            trigger: 'focus',
            placement: 'left',
            boundary: 'window',
            offset: "-40",
            title: '',
            container: addNewCardModal.$modal.closest( ".modal.fade" )[0],
        });
    };

    this.setCardAddedCallback = function(callback) {
        addNewCardModal._onCardAdded = callback;
    };

    this.setModalHiddenCallback = function(callback) {
        addNewCardModal._onModalHidden = callback;
    };

    this.show = function() {
        addNewCardModal._resetModal();
        addNewCardModal.$modal.modal('show');
    };

    this.hide = function() {
        addNewCardModal.$modal.modal('hide');
    };

    this._getCardData = function( callback ) {
        checkout.payment.models.paymentMethodFromNewCard(
            checkout.billinfo.getData().billing,
            checkout.cart.totals.values.remaining,
            addNewCardModal.newCard.hostedFieldsInterface,
            callback
        );
    };

    this._resetModal = function () {
        var $newCardContainer = addNewCardModal.$modal.find( ".js-new-card" );
        addNewCardModal.newCard = new CheckoutV2.PaymentV2.CreditCard.New(
            checkout,
            $newCardContainer,
            true
        );
    }

    this._init();
};
